import React from "react";

const DiscountSettings = ({
  discountData,
  handleDiscountChange,
  handleUpdateDiscount,
  handleRemoveDiscount,
  loading,
  discounts = [],
  formatAmount,
}) => {
  return (
    <>

    <div className="space-y-6 montserrat-font-1">
      {/* ================= DISCOUNT LIST ================= */}
      {discounts.length > 0 && (
        <div className="grid md:grid-cols-2 gap-4">
          {discounts.map((d, i) => (
            <div key={i} className="bg-white border rounded-xl p-5 shadow-sm">
              {/* Header */}
              <div className="flex justify-between items-center mb-3 border-b pb-2">
                <h2 className="text-green-700 font-semibold">
                  Currently Applied Discount
                </h2>

               <button
  type="button"
  onClick={() => handleRemoveDiscount(d)}
  disabled={loading}
  className={`text-white text-sm px-3 py-1 rounded ${
    loading
      ? "bg-red-300 cursor-not-allowed"
      : "bg-red-500 hover:bg-red-600"
  }`}
>
  {loading ? "Removing..." : "Remove"}
</button>
              </div>

              {/* Body */}
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-gray-600">Discount:</span>
                  <span>
                    {d.discount_type === "fixed" ? "₹" : ""}
                    {formatAmount(d.discount)}
                    {d.discount_type === "percentage" ? "%" : ""}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-600">Type:</span>
                  <span>{d.discount_type}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-600">From:</span>
                  <span>₹{formatAmount(d.from_amt)}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-600">To:</span>
                  <span>₹{formatAmount(d.to_amt)}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-600">Maximum Discount Limit:</span>
                  <span>₹{formatAmount(d.max_discount)}</span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-600">Order Type:</span>
                  <span>{d.order_type}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ================= UPDATE FORM ================= */}
      <div className="bg-white p-6 rounded-2xl">
        <h2 className="text-green-700 font-semibold text-lg mb-6">
          Update Discount
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm text-gray-700 mb-1">Discount</label>
            <input
              type="text"
              name="discount"
              value={discountData.discount}
              onChange={handleDiscountChange}
              placeholder="Enter Discount"
              className="w-full px-3 py-2 rounded-lg border"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">
              From Amount
            </label>
            <input
              type="text"
              name="fromAmount"
              value={discountData.fromAmount}
              onChange={handleDiscountChange}
              placeholder="Enter From Amount"
              className="w-full px-3 py-2 rounded-lg border"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">
              To Amount
            </label>
            <input
              type="text"
              name="toAmount"
              value={discountData.toAmount}
              onChange={handleDiscountChange}
              placeholder="Enter To Amount"
              className="w-full px-3 py-2 rounded-lg border"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">
              Maximum Discount Limit
            </label>
            <input
              type="text"
              name="maxDiscount"
              value={discountData.maxDiscount}
              onChange={handleDiscountChange}
              placeholder="Enter Maximum Discount Limit"
              className="w-full px-3 py-2 rounded-lg border"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">
              Discount Type
            </label>
            <select
              name="discountType"
              value={discountData.discountType}
              onChange={handleDiscountChange}
              className="w-full px-3 py-2 rounded-lg border"
            >
              <option value="">Select Discount Type</option>
              <option value="fixed">Fixed</option>
              <option value="percentage">Percentage</option>
            </select>
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">
              Order Type
            </label>
            <select
              name="orderType"
              value={discountData.orderType}
              onChange={handleDiscountChange}
              className="w-full px-3 py-2 rounded-lg border"
            >
              <option value="">Select Order Type</option>
              <option value="homeDelivery">Home Delivery</option>
              <option value="takeaway">Takeaway</option>
              <option value="dining">Dining</option>
            </select>
          </div>
        </div>

        <div className="mt-6">
          <button
            onClick={handleUpdateDiscount}
            disabled={loading}
            className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-lg"
          >
            {loading ? "Updating..." : "Update Discount"}
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default DiscountSettings;
